import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

//解决路由导航到统一路径重复报错的问题
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => console.log(err))
// }


const routes = [
  {
    path: '/',
    name: "homepage",
    redirect: "/home",
    component: () => import('../views/Home.vue'),
    children: [
      // 首页
      {
        path: 'home',
        name: 'home',
        fullPath: "/home",
        component: () => import('../views/HomePage.vue'),
        meta: {
          name: "南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      // 操作步骤
      {
        path: 'shiyong',
        name: 'shiyong',
        component: () => import('../views/shiyong.vue'),
        meta: {
          name: "钉钉扫码试用",
        },
      },
      // 关于我们
      {
        path: 'aboutUs',
        name: 'aboutUs',
        component: () => import('../views/AboutUs.vue'),
        meta: {
          name: "关于我们-企业简介_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      // 公司动态
      {
        path: 'news',
        name: 'news',
        component: () => import('../views/News.vue'),
        meta: {
          fullPath: "/news",
          name: "公司动态_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      // 热门活动
      {
          path: "popularActivities",
          name: 'popularActivities',
          component: () => import("../views/PopularActivities.vue"),
          meta: {
            fullPath: "/popularActivities",
            name: "热门活动_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
          },
      },
      // 团队风采
      {
        path: "teamStyle",
        name: 'teamStyle',
        component: () => import("../views/TeamStyle.vue"),
        meta: {
          fullPath: "/teamStyle",
          name: "团队风采_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      //钉钉资讯
      {
        path: "realInfo",
        name: 'realInfo',
        component: () => import("../views/RealInfo.vue"),
        meta: {
          fullPath: "/realInfo",
          name: "钉钉资讯_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      // 钉钉教程
      {
        path: "course",
        name: 'course',
        component: () => import("../views/Course.vue"),
        meta: {
          fullPath: "/course",
          name: "钉钉教程_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      // 解决方案
      {
        path: 'solution',
        name: 'solution',
        component: () => import('../views/Solution.vue'),
        meta: {
            ullPath: "/solution",
            name: "解决方案_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: 'dingdingda',
        name: 'dingdingda',
        component: () => import('../views/Dingdingda.vue'),
        meta: {
            ullPath: "/dingdingda",
            name: "钉钉搭_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      // 钉钉专业版
      {
        path: "major",
          name: 'major',
          component: () => import("../views/Major.vue"),
          meta: {
            fullPath: "/major",
            name: "钉钉专业版_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
          },
      },
      {
        path: "onlyDingding",
        name: 'onlyDingding',
        component: () => import("../views/OnlyDingding.vue"),
        meta: {
          name: "专属钉钉_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "haveDingding",
        name: 'haveDingding',
        component: () => import("../views/HaveDingding.vue"),
        meta: {
          name: "专有钉钉_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "videoconferencing",
        name: 'videoconferencing',
        component: () => import("../views/Videoconferencing.vue"),
        meta: {
          name: "视频会议_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "teamB",
        name: 'teamB',
        component: () => import("../views/teamB.vue"),
        meta: {
          name: "Teambition_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "engineeringManagement",
        name: 'engineeringManagement',
        component: () => import("../views/EngineeringManagement.vue"),
        meta: {
          name: "工程管理_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "digitalFactory",
        name: 'digitalFactory',
        component: () => import("../views/DigitalFactory.vue"),
        meta: {
          name: "数字工厂_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "intelligentFireFighting",
        name: 'intelligentFireFighting',
        component: () => import("../views/IntelligentFireFighting.vue"),
        meta: {
          name: "智慧消防_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "numDistrictCounty",
        name: 'numDistrictCounty',
        component: () => import("../views/NumDistrictCounty.vue"),
        meta: {
          name: "数字区县_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "numHighSchool",
        name: 'numHighSchool',
        component: () => import("../views/NumHighSchool.vue"),
        meta: {
          name: "数字高校_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "numShop",
        name: 'numShop',
        component: () => import("../views/NumShop.vue"),
        meta: {
          name: "数字零售店_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "numHotel",
        name: 'numHotel',
        component: () => import("../views/NumHotel.vue"),
        meta: {
          name: "酒店数字化_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "ERPline",
        name: 'ERPline',
        component: () => import("../views/ERPline.vue"),
        meta: {
          name: "ERP业务在线_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "highWork",
        name: 'highWork',
        component: () => import("../views/HighWork.vue"),
        meta: {
          name: "高级工作台_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "onlyWork",
        name: 'onlyWork',
        component: () => import("../views/OnlyWork.vue"),
        meta: {
          name: "定制工作台_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "OACloud",
        name: 'OACloud',
        component: () => import("../views/OACloud.vue"),
        meta: {
          name: "云端办公室_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: 'server',
          name: 'server',
          component: () => import('../views/HomePage.vue'),
          meta: {
            name: "产业服务_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
          },
      },
      {
        path: "roundAssets",
        name: 'roundAssets',
        component: () => import("../views/RoundAssets.vue"),
        meta: {
          name: "圆资产_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "dingFlash",
        name: 'dingFlash',
        component: () => import("../views/DingFlash.vue"),
        meta: {
          name: "钉闪会_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "dingdingWord",
        name: 'dingdingWord',
        component: () => import("../views/DingdingWord.vue"),
        meta: {
          name: "钉钉文档_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "didaima",
        name: 'didaima',
        component: () => import("../views/diDaiMa.vue"),
        meta: {
          name: "宜搭_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "yida",
        name: 'yida',
        component: () => import("../views/Yida.vue"),
        meta: {
          name: "宜搭_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "yunshu",
        name: 'yunshu',
        component: () => import("../views/Yunshu.vue"),
        meta: {
          name: "云枢_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: "chuanyun",
        name: 'chuanyun',
        component: () => import("../views/Chuanyun.vue"),
        meta: {
          name: "氚云_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: 'dingConnect',
        name: 'dingConnect',
        component: () => import('../views/DingConnect.vue'),
        meta: {
          name: "钉钉智连_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: 'customerCase',
        name: 'customerCase',
        component: () => import('../views/CustomerCase.vue'),
        meta: {
          name: "客户案例_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: 'talentPeople',
        name: 'talentPeople',
        component: () => import('../views/TalentPeople.vue'),
        meta: {
          name: "人才招聘_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
      {
        path: 'page404',
        name: 'page404',
        component: () => import('../views/page404.vue'),
        meta: {
          name: "page404_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
       {
         path: 'getUs',
         name: 'getUs',
         component: () => import('../views/GetUs.vue'),
         meta: {
           fullPath: "/getUs",
           name: "联系我们_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
         },
       },
       {
        path: 'lizis',
        name: 'lizis',
        component: () => import('../views/lizis.vue'),
        meta: {
          fullPath: "/lizis",
          name: "联系我们_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
        },
      },
       {
         path: 'zhaopinJiangli',
         name: 'zhaopinJiangli',
         component: () => import('../views/ZhaopinJiangli.vue'),
         meta: {
           fullPath: "/zhaopinJiangli",
           name: "软件项目经理_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
         },
       },
       {
         path: 'qianduanKaifa',
         name: 'qianduanKaifa',
         component: () => import('../views/QianduanKaifa.vue'),
         meta: {
           fullPath: "/qianduanKaifa",
           name: "前端开发_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
         },
       },
       {
         path: 'JavaKaifa',
         name: 'JavaKaifa',
         component: () => import('../views/JavaKaifa.vue'),
         meta: {
           fullPath: "/JavaKaifa",
           name: "JAVA开发_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
         },
       },
       {
         path: 'dingdingxiaoshou',
         name: 'dingdingxiaoshou',
         component: () => import('../views/Dingdingxiaoshou.vue'),
         meta: {
           fullPath: "/dingdingxiaoshou",
           name: "钉钉销售_南京壹宝通信息技术有限公司-阿里钉钉金牌定制服务商",
         },
       },
      //  客户案例路由
       {
         path: 'customerCase/jianyezhengfu',
         name: 'jianyezhengfu',
         component: () => import('../pages/kehuanli/jianyerenminzhengfu.vue'),
         meta: {
           fullPath: "/customerCase/jianyezhengfu",
           name: "建邺区人民政府-客户案例",
         },
       },
        {
         path: 'zhibo',
         name: 'zhibo',
         component: () => import('../views/zhibo.vue'),
         meta: {
           fullPath: "/zhibo",
           name: "预约直播",
         },
       },
       
    ]
  }
]



const router = new VueRouter({
  mode: 'history',
  routes

})

export default router
